import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentUpdate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const updateStatus = async () => {
    const status = searchParams.get('paymentstatus');
    const appointmentid = searchParams.get('appointmentid');
    const token = (window as any).APPUSER?.user?.token;

    if (status === "success" && appointmentid) {
      // Compressing payload to single line as requested
      const payload = {dataset:[{_id:appointmentid, status:"Booked", datatype:"appointmentdata"}]};
      
      try {
        await fetch("/updateappdata", {
          method: "POST",
          headers: {"Content-Type":"application/json", "Authorization":"Bearer " + token},
          body: JSON.stringify(payload)
        });
      } catch (err) {
        console.error("Payment update failed", err);
      }
    } else {
      alert("Payment failed or was cancelled.");
    }
    
    // Final redirect back to dashboard
    navigate("/dashboard");
  };

  useEffect(() => { updateStatus(); }, []);

  return (
    <div className="content-area empty-state">
      <h3 className="dash-title">Processing Payment Update...</h3>
      <p className="card-text">Please do not refresh the page.</p>
    </div>
  );
};

export default PaymentUpdate;